import React, {useState, useEffect, useRef} from 'react'; // 17 Sep 2025
import {
  PlusIcon,
  MinusIcon,
  PencilSquareIcon,
  TrashIcon,
  PlusCircleIcon,
  ArrowUpCircleIcon,
  CalendarDaysIcon,
  CheckCircleIcon,
  ArrowPathIcon,        // 17 Sep 2025
  ArrowRightIcon,       // 17 Sep 2025
  ChevronLeftIcon,      // 28 Sep 2025
  ChevronRightIcon,     // 28 Sep 2025
} from "@heroicons/react/24/outline"

import {
UserIcon,
UserGroupIcon
} from "@heroicons/react/24/solid" // 17 Sep 2025

import ExploreOutlinedIcon from "@mui/icons-material/ExploreOutlined" 

// 30 Sep 2025
import EtUserActionEnablerIcon1SVGComp from "@/assets/img/icons/svgComp/EtUserActionEnablerIcon1SVGComp"
import EtUserActionOutcomeIcon1SVGComp from "@/assets/img/icons/svgComp/EtUserActionOutcomeIcon1SVGComp"

import EtUserAssignedActionCard from "@/features/userActions/EtUserAssignedActionCard" // 17 Sep 2025 - to show assigned user action progress

import {  useGetUserActionsQuery } from "@/features/userActions/userActionsApiSlice" // 17 Sep 2025

import EtUserActionPerformanceSelfChart from "@/components/actions/EtUserActionPerformanceSelfChart" // 30 Sep 202

import { formatDate, formatDateTime } from "@/utils/formatDate"
import { getTimeSince } from "@/utils/EtGetTimeSince"
import { differenceInDays } from "date-fns"

import { skipToken } from '@reduxjs/toolkit/query'; // 17 Sep 2025

// 27 Sep 2025
import { getCurrentRecurrenceLogEntry, getNextRecurrenceLogDate } from "@/utils/logUtils";

// 28 Sep 2025
import moment from 'moment-timezone';

// 05 Jan 2026
import { CircularProgressbarWithChildren } from 'react-circular-progressbar'

// 06 Jan 2026
import EtUserActionPerformanceCollectiveChart from "@/components/actions/EtUserActionPerformanceCollectiveChart"
import EtUserActionPerformanceCollectiveTimeSeriesChart from "@/components/actions/EtUserActionPerformanceCollectiveTimeSeriesChart"

// 07 Jan 2026
import User from "@/components/common/user/User"

import { userProfileIcon2 } from "@/assets/img/imgAssets"

const EtUserSessionActionCard = ({
  action,
  actionIndex,
  showDetails,
  onToggleDetails,
  actionNote,
  progressValue,
  onNoteChange,
  onProgressChange,
  onSave,
  onEdit,
  onDelete,
  isSelfCreated,
  performanceSnapshot,   // ✅ 22 Dec 2025 NEW
  collectiveActions, // 06 Jan 2026
  collectiveRole, // 06 Jan 2026
}) => {

  // Author - Atul Pandey
  // First Created - 10 Sep 2025
  // Purpose - To display each use session action details
  // Inherited from ActionCard component inside EtTrinityWebLandingAction
  // Updated - 17 Sep 2025 - Recurrence Action Icon
  // Updated - 17 Sep 2025 - Action Assignment & Performance Sections Options: Action Detail, Action Progress, Action Performance
  // Updated - 17 Sep 2025 - Action Assignment using redux - assignedFromAction param : skipToken
  // Updated - 26 Sep 2025 - Actual Value update
  // Updated - 27 Sep 2025 - Current Log refinements 
  // Updated - 28 Sep 2025 - Refinements for recurring action progress value for handleNoteChange and handleProgressChange
  // Updated - 28 Sep 2025 - Recurrence Log Trail
  // Updated - 30 Sep 2025 - Action Performance Tab refinement starts
  // Updated - 16 Nov 2025 - set default activeInnerTab to Action Progress
  // Updated - 17 Nov 2025 - fixed the icon issue - clipPath removed from the Enabler Icon (Outcome Icon was fine)
  // Updated - 22 Dec 2025 - performanceSnapshot refinement - collective and roll ups
  // Updated - 30 Dec 2025 - Fix - for "non-Daily" recurring log cards 
  // Updated - 01 Jan 2026 - Fix - for "non-Daily" recurring log card display for showing current time period opening 
  // Updated - 05 Jan 2026 - Refinements for collective performance data display
  // Updated - 06 Jan 2026 - Refinements for collective performance data display - collectiveActions prop bringing normalized data

  // 0 - Validate incoming data:

  // console.log('action', action)

  // console.log("actionGoalRole", action?.actionGoalRole, action?._id);
  // console.log('action targetValue: ', action?.targetValue)
  // console.log('action actionUoM: ', action?.actionUoM)
  
//   console.log('actionIndex', actionIndex)
  // console.log('performanceSnapshot', performanceSnapshot)
  // console.log('collectiveActions', collectiveActions)
  // console.log('collectiveRole', collectiveRole)

  // 1 - State variables - 17 Sep 2025
  // const [activeInnerTab, setActiveInnerTab] = useState("Action Detail") // 16 Nov 2025 - commented
  const [activeInnerTab, setActiveInnerTab] = useState("Action Progress") // 16 Nov 2025
  const [selectedActionProgressFocusTab, setSelectedActionProgressFocusTab] = useState("self")
  const [selectedActionPerformanceFocusTab, setSelectedActionPerformanceFocusTab] = useState("self")

  // 🆕 06 Jan 2026 - Collective Performance sub-tabs
  const [activeCollectivePerformanceTab, setActiveCollectivePerformanceTab] =
  useState("chart"); // chart | contributions


  // 26 Sep 2025 - actual Value capture
  const [localActualValue, setLocalActualValue] = useState(() => {
    if (action?.actionRecurrencePattern === "OneTime") {
      return action?.actualValue || 0;
    } else {
      const today = new Date().toISOString().split("T")[0];
      const currentLog = action?.recurringActionLog?.find((log) =>
        log.logDate?.startsWith(today)
      );
      return currentLog?.actualValue || 0;
    }
  });

  // 2a - Get UserInfo from action - 17 Sep 2025
  // const userInfo = {
  //   _id: action?.userId?._id,
  //   username: action?.userId?.username,
  //   name: action?.userId?.name,
  // }
  
  //  console.log('userInfo', userInfo)

  
   // 2b - Get userActions data for assignedUsers matching
   const { data: userActionsWithAssignedClones = [], isLoading: isLoadingAssigned } =
    useGetUserActionsQuery(
      // showDetails && activeInnerTab === "Action Progress" && selectedActionProgressFocusTab === "collective"
      activeInnerTab === "Action Progress" && selectedActionProgressFocusTab === "collective"
        ? { assignedFromAction: action._id }
        : skipToken
    );

    // console.log('userActionsWithAssignedClones', userActionsWithAssignedClones)

    const extractEntitiesFromAdapter = (dataAdapter) => {
    if (!dataAdapter || !dataAdapter.ids || !dataAdapter.entities) return [];
    return dataAdapter.ids.map((id) => dataAdapter.entities[id])
  };

  const userAssignedActions = extractEntitiesFromAdapter(userActionsWithAssignedClones)

  // console.log('userAssignedActions', userAssignedActions)

  // 3a -  Progress bar coloring
  const getBgColor = (userInfoData) => {
    const today = new Date()
    const completeByDate = new Date(action?.completeBy)
    const daysDifference = differenceInDays(completeByDate, today)

    if (daysDifference < 0) return "bg-red-600 text-white"
    if (daysDifference < 1) return "bg-orange-400 text-white"
    if (daysDifference < 3) return "bg-yellow-400"
    return "bg-lime-400"
  }

  // 3b -  Icon coloring
  const getIconClr = (action) => {
    const today = new Date()
    const completeByDate = new Date(action?.completeBy)
    const daysDifference = differenceInDays(completeByDate, today)

    if (daysDifference < 0) return "#dc2626"
    if (daysDifference < 1) return "#f97316"
    if (daysDifference < 3) return "#facc15"
    return "#84cc16"
  }

  // 3c - Days Difference
  const getDaysDifference = (action) => {
    const today = new Date()
    const completeByDate = new Date(action?.completeBy)
    return differenceInDays(completeByDate, today)
  }

  // 3d - 28 Sep 2025 - scrollable log container ref & scroll functions
  const logScrollRef = useRef(null); // 👈 new ref for scrollable log container
  
  const scrollLeft = () => {
    if (logScrollRef.current) {
      logScrollRef.current.scrollBy({ left: -150, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (logScrollRef.current) {
      logScrollRef.current.scrollBy({ left: 150, behavior: "smooth" });
    }
  };

  // 3e - 28 Sep 2025 - scroll to today's log on mount
  const todayLogRef = useRef(null);

  useEffect(() => {
    // if (todayLogRef.current) { // 30 Dec 2025 - conditioned it only for the daily cards
    if (todayLogRef.current && action.actionRecurrencePattern === "Daily") {
      todayLogRef.current.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  }, []);


  // 4 - Create Markup
  const createMarkup = (htmlContent) => {
    return { __html: htmlContent?.replace(/\n/g, "<br />") }
  }

  // 5a - 27 Sep 2025 - Currentlog
  const currentLog = getCurrentRecurrenceLogEntry(action)
  const nextLogDate = getNextRecurrenceLogDate(action);

  // 30 Dec 2025 - Active recurrence window (Daily / Weekly / Monthly / etc)
  const isActivePeriod = Boolean(currentLog);

  
  // 5b - 28 Sep 2025 - Refinements for recurring action progress value for handleNoteChange and handleProgressChange
  const logDateKey = currentLog?.logDate
  ? moment(currentLog.logDate).format("YYYY-MM-DD")
  : null;

  // console.log('currentLog', currentLog)

  // 6 - getFirstName helper - 05 Jan 2026
  const getFirstName = (name = "") => name.split(" ")[0];


  return(
  <div className="bg-gray-100 rounded m-1 p-1 font-poppins">
      <div className="grid grid-cols-12 justify-between items-center">
        <div className="col-span-5 flex items-center">
          <div
            onClick={onToggleDetails}
            className="cursor-pointer mx-2 rounded-full h-5 w-5 flex justify-center items-center hover:bg-white"
          >
            {showDetails ? (
              <MinusIcon className="h-4 w-4 text-orange-600" />
            ) : (
              <PlusIcon className="h-4 w-4 text-orange-600" />
            )}
          </div>
          <div className="flex justify-start items-center">
            <p className="text-sm text-gray-600 font-bold mx-1 px-1">
                {/* Action {actionIndex + 1} */}
                {actionIndex +1}.
            </p>

            {/* Action Assignment Icon - 17 Sep 2025 */}
            <div 
              className="mx-2 cursor-pointer" 
              title={
               ["Delegated", "Collective"].includes(action?.assignmentType)
                ? action?.assignmentType
                : action?.assignedUsers?.length > 0
                ? "Collective"
                : "Self"
              } 
              onClick={onToggleDetails}
            >
              {["Delegated", "Collective"].includes(action?.assignmentType) ||
                (action?.assignedUsers?.length > 0) ? (
              <div className="flex justify-center items-center rounded-full h-6 w-6 bg-white hover:bg-orange-100 p-1">
                 <UserGroupIcon className="h-5 w-5 text-orange-600" />
              </div>
             
              ) : (
                <div className="flex justify-center items-center rounded-full h-6 w-6 bg-white hover:bg-orange-100 p-1">
                  <UserIcon className="h-5 w-5 text-orange-600" />
                </div> 
              )}
            </div>

            {/* Action Recurrence Icon - 17 Sep 2025 */}
            <div className="mx-2 cursor-pointer" title={action?.actionRecurrencePattern} onClick={onToggleDetails}>
              {action?.actionRecurrencePattern === "OneTime" ? (
              <div className="flex justify-center items-center rounded-full h-5 w-5 bg-gradient-to-r from-orange-600 to-orange-600 via-orange-800 hover:from-orange-400 hover:via-orange-600 hover:to-black shadow-lg shadow-black">
                 <ArrowRightIcon className="h-4 w-4 text-white" />
              </div>
             
              ) : (
                <div className="flex justify-center items-center rounded-full h-5 w-5 bg-gradient-to-r from-orange-600 to-orange-600 via-orange-800 hover:from-orange-400 hover:via-orange-600 hover:to-black shadow-lg shadow-black">
                  <ArrowPathIcon className="h-4 w-4 text-white" />
                </div>
              
            )}
            </div>

            {/* 30 Sep 2025 - User ActionGoalRole - Enabler / Outcome */}
            <div className="mx-2 cursor-pointer" title={action?.actionGoalRole} onClick={onToggleDetails}>

              {/* {console.log('🔍 Rendering actionGoalRole:', action?.actionGoalRole, 'Action:', action?.userActionName)} */}

              
              {action?.actionGoalRole === "Enabler" ? (
              <div className="flex justify-center items-center rounded-full h-5 w-5 bg-gradient-to-r from-orange-600 to-orange-600 via-orange-800 hover:from-orange-400 hover:via-orange-600 hover:to-black shadow-lg shadow-black">
                 {/* {console.log('✅ Rendering Enabler icon - about to render SVG')} */}
                  <EtUserActionEnablerIcon1SVGComp className="h-4 w-4 text-white" />
                  {/* {console.log('✅ After SVG render')} */}
                 {/* <EtUserActionEnablerIcon1SVGComp width={16} height={16} className="text-white" /> */}
              </div>
             
              ) : (
                <div className="flex justify-center items-center rounded-full h-5 w-5 bg-gradient-to-r from-orange-600 to-orange-600 via-orange-800 hover:from-orange-400 hover:via-orange-600 hover:to-black shadow-lg shadow-black">
                  <EtUserActionOutcomeIcon1SVGComp className="h-4 w-4 text-white" />
                  {/* <EtUserActionOutcomeIcon1SVGComp width={16} height={16} className="text-white" /> */}
                </div>
              
            )}

            {/* {action?.actionGoalRole === "Enabler" && (
              <div className="flex justify-center items-center rounded-full h-5 w-5 bg-gradient-to-r from-orange-600 to-orange-600 via-orange-800 hover:from-orange-400 hover:via-orange-600 hover:to-black shadow-lg shadow-black">
                <EtUserActionEnablerIcon1SVGComp className="h-4 w-4 text-white" />
              </div>
            )} */}
            </div>


            
            <p className="text-xs font-bold">
              {action?.userActionName || "Unnamed Action"}
            </p>
          </div>
        </div>

        <div className="col-span-2">
          <div className="rounded-full bg-gray-300 relative">
            <div
              className="rounded-full bg-[#552a9a]"
              style={{
                width: `${action?.userActionProgress || 0}%`,
                height: "30%",
              }}
            ></div>
            <p className={`text-[8px] py-1 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 ${action?.userActionProgress < 45 ? "text-black" : "text-white"}`}>
              {action?.userActionProgress}%
            </p>
          </div>
        </div>

        <div className="col-span-2 flex justify-center items-center">
          {action?.userActionStatus === "Completed" ? (
            <CheckCircleIcon className="h-4 w-4 text-lime-600" />
          ) : (
            <ExploreOutlinedIcon
              fontSize="small"
              sx={{
                color:
                  action?.userActionStatus !== "Planned"
                    ? getIconClr(action)
                    : getDaysDifference(action) < 3
                    ? getIconClr(action)
                    : "#d1d5db",
              }}
            />
          )}
          <p
            className={`text-[9px] mx-1 ${
              action?.userActionStatus === "Completed"
                ? "bg-lime-600 text-white"
                : action?.userActionStatus !== "Planned"
                ? getBgColor(action)
                : getDaysDifference(action) < 3
                ? getBgColor(action)
                : "text-gray-600"
            } rounded-full px-2`}
          >
            {action?.userActionStatus}
          </p>
        </div>

        <div className="col-span-3 flex justify-between items-center">
          <div className="flex items-center text-[9px] text-gray-600">
            <CalendarDaysIcon className="m-2 h-5 w-5 text-orange-600" />
            <span className="bg-white border px-2 py-[1px] rounded border-orange-400">
              {formatDate(action?.completeBy)}
            </span>
          </div>

          {isSelfCreated && (
            <div className="flex space-x-1">
              <PencilSquareIcon
                onClick={onEdit}
                className="h-4 w-4 text-orange-600 cursor-pointer"
              />
              <TrashIcon
                onClick={onDelete}
                className="h-4 w-4 text-orange-600 cursor-pointer"
              />
            </div>
          )}
        </div>
      </div>

      {/* Expandable Section */}
      {showDetails && (
        <div className="mt-2 m-1 p-1 bg-white rounded">

          {/* 17 Sep 2025 - 🟠 Action Tabs – Detail | Progress | Performance */}
          <div className="flex justify-start space-x-4 px-3 py-2 border-b font-poppins">
            {["Action Detail", "Action Progress", "Action Performance"].map((tab) => (
              <button
                key={tab}
                className={`font-semibold px-3 py-1 rounded-t ${
                  activeInnerTab === tab
                    ? "bg-orange-200 text-orange-800"
                    : "text-gray-500"
                }`}
                onClick={() => setActiveInnerTab(tab)}
              >
                <div className="flex items-center space-x-2 px-1 mx-1">
                  <p className="text-sm font-medium">{tab}</p>
                </div>
              </button>
            ))}
          </div>

          {activeInnerTab === "Action Detail" && action?.userActionDesc && (
            <div className='bg-gray-200 rounded m-1 p-1'>
              <p className='font-bold m-1 p-1'>Description</p>
              <div
                className="bg-gray-50 rounded p-2 fix-nested-lists"
                dangerouslySetInnerHTML={createMarkup(action?.userActionDesc)}
              />
              <div className='bg-white rounded'>

                <div className="grid grid-cols-6 justify-between items-center m-1 p-2 pb-2 border-b">
                  
                  <div className='col-span-2 flex justify-start items-center'>
                    <p className="col-span-1 font-bold text-orange-800 mx-1 px-1">Action's Goal Role : </p>
                    <p className="col-span-1 text-center text-gray-800 font-bold mx-1 px-2 rounded-full bg-orange-100">{action?.actionGoalRole}</p>
                  </div>
                  
                  <div className='col-span-2 flex justify-start items-center'>
                    <p className="col-span-1 font-bold text-orange-800 mx-1 px-1">Recurrence : </p>
                    <p className="col-span-1 text-center text-gray-800 font-bold mx-1 px-2 rounded-full bg-orange-100">{action?.actionRecurrencePattern}</p>
                  </div>
                  
                </div>   
              
              
              </div>
              
              
            </div>
          )}

          {activeInnerTab === "Action Progress" && (
            <>
            {/* Sub-tabs for Self / Collective - inside Action Progress */}
            <div className="flex justify-start space-x-4 border-b border-gray-300 py-1 px-2 mb-2">
              {[
                { key: "self", label: "Self", Icon: UserIcon },
                { key: "collective", label: "Collective", Icon: UserGroupIcon }
              ].map(({ key, label, Icon }) => (
                <button
                  key={key}
                  onClick={() => setSelectedActionProgressFocusTab(key)}
                  className={`flex items-center space-x-2 px-3 py-1 text-sm font-semibold border-b-2 ${
                    selectedActionProgressFocusTab === key
                      ? "border-orange-600 text-orange-600"
                      : "border-transparent text-gray-500"
                  }`}
                >
                  <div
                    className={`h-7 w-7 flex justify-center items-center rounded-full ${
                      selectedActionProgressFocusTab === key
                        ? "bg-gradient-to-r from-orange-600 to-orange-800 shadow-md"
                        : "bg-gray-100 hover:bg-orange-100"
                    }`}
                  >
                    <Icon
                      className={`h-4 w-4 ${
                        selectedActionProgressFocusTab === key ? "text-white" : "text-orange-600"
                      }`}
                    />
                  </div>
                  <p className="text-sm font-medium">{label}</p>
                  {/* Optional Count */}
                  {/* <div className="rounded-full flex justify-center items-center h-5 w-5 border border-orange-300 bg-gray-50">
                    <p className="text-orange-600 text-[10px]">
                      {focusCounts[key] || 0}
                    </p>
                  </div> */}
                </button>
              ))}
            </div>

              {selectedActionProgressFocusTab === "self" && (
                <>
                {/* Past Notes */}
                {action?.userActionNotes?.length > 0 && (
                  <div className="bg-gray-300 rounded mt-2 p-2">
                    <p className="font-bold text-xs mb-1">Action Progress Trail:</p>

                    {action.userActionNotes
                      .slice()
                      .sort(
                        (a, b) =>
                          new Date(b.actionNoteDate) - new Date(a.actionNoteDate)
                      )
                      .map((note, index) => (
                        <div
                          key={note._id + index}
                          className="bg-gray-50 rounded p-2 my-1"
                        >
                          <div className="grid grid-cols-10 justify-between items-center m-1 p-1 w-full">
                              <div className="col-span-5 flex justify-start items-center">
                              <div>
                                  <p className="font-bold text-[9px] mx-1 py-[1px]">
                                  {index + 1}.
                                  </p>
                              </div>
                              <div>
                                  <p className="text-[9px] mx-1 rounded-full px-2 py-[1px] bg-lime-200 w-18">
                                  {getTimeSince(note?.actionNoteDate)}
                                  </p>
                              </div>
                              <div>
                                  <p className="text-[9px] mx-1 py-[1px]">
                                  {note?.actionNoteText}
                                  </p>
                              </div>
                              </div>

                              <div className="col-span-1">
                              <p className="text-[9px] text-gray-600">
                                  Action Progress:
                              </p>
                              </div>

                              {/* 11 Jun 2024 - action progress bar for each note */}

                              <div className="col-span-2">
                                <div className="rounded-full bg-gray-300 relative">
                                      <div
                                      className="rounded-full bg-[#552a9a]"
                                      style={{
                                          width: `${note?.actionNoteProgress || 0}%`,
                                          // height: "36%",
                                          height: "10px",
                                      }}
                                      ></div>
                                      <p className={`text-[8px] absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 ${note?.actionNoteProgress < 45 ? "text-black" : "text-white"}`}>
                                      {note?.actionNoteProgress}%
                                      </p>
                                  </div>
                              </div>

                              <div className="col-span-2 flex justify-start items-center">
                                  <div className="mx-2 px-2 w-full">
                                      <p className="text-[9px] text-gray-400 mx-1 rounded-full px-2">
                                      {formatDateTime(note?.actionNoteDate)}
                                      </p>
                                  </div>
                              </div>
                          </div>
                        </div>
                      ))}
                  </div>
                )}

                {/* 28 Sep 2025 - Recurrence Log Trail */}
                {action?.actionRecurrencePattern !== "OneTime" && (
                  <div className="bg-gray-300 rounded mt-2 p-2">
                    <p className="font-bold text-xs m-1 p-1">Recurring Action Log Trail:</p>
                    
                    <div className="relative bg-gray-50 rounded p-2 my-1">
                      {/* Optional Left Arrow */}
                      {/* <button className="absolute left-0 top-1/2 transform -translate-y-1/2 bg-white z-10">◀</button> */}
                      <button 
                        onClick={scrollLeft}
                        className="absolute left-0 top-1/2 transform -translate-y-1/2 bg-white z-10 p-1 rounded-full shadow"
                      >
                        <ChevronLeftIcon className="h-5 w-5 text-gray-600" />
                      </button>

                      <div 
                        ref={logScrollRef}
                        className="flex overflow-x-auto gap-2 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100 px-[2rem]"
                      >
                        {action?.recurringActionLog?.map((log, index) => {
                          // 30 Dec 2025
                          const logMoment = moment.utc(log.logDate).tz(action.userTimeZone || "UTC");
                          const today = moment().tz(action.userTimeZone || "UTC").startOf("day");

                          const isDaily = action.actionRecurrencePattern === "Daily";

                          // Only Daily logs have "today"
                          // const isToday = isDaily && logMoment.isSame(today, "day");
                          // const isActivePeriod = currentLog?._id === log._id;

                          const isThisLogActive = currentLog?._id === log._id;

                          const isCurrentLog =
                            currentLog && log._id.toString() === currentLog._id.toString();

                          const isFuture = logMoment.isAfter(
                            moment(currentLog?.logDate).tz(action.userTimeZone || "UTC")
                          );

                          const isPast =
                            currentLog &&
                            logMoment.isBefore(
                              moment(currentLog.logDate).tz(action.userTimeZone || "UTC")
                            );


                          // const isFuture = logMoment.isAfter(today);
                          // const isPast = logMoment.isBefore(today);



                          // const logDate = moment(log.logDate).startOf("day");
                          // const today = moment().startOf("day");
                          // const isToday = logDate.isSame(today);
                          // const isFuture = logDate.isAfter(today);
                          // const isPast = logDate.isBefore(today);

                          let bgColor = "bg-gray-100";

                          // 30 Dec 2025
                          if (isCurrentLog) {
                            // 🔓 Active recurrence window
                            if (!log?.logged) bgColor = "bg-orange-200";
                            else if (log.progress < 100) bgColor = "bg-yellow-300";
                            else bgColor = "bg-lime-600";

                          } else if (isPast) {
                            // ⛔ Past & missed
                            if (!log?.logged) bgColor = "bg-red-600";
                            else if (log.progress < 100) bgColor = "bg-yellow-300";
                            else bgColor = "bg-lime-600";

                          } else if (isFuture) {
                            bgColor = "bg-gray-200";
                          }




                          // if (isActivePeriod) {
                          // if (isThisLogActive) {
                          //   // 🔓 Current recurrence window (Daily / Weekly / Monthly / etc)
                          //   if (!log?.logged) bgColor = "bg-orange-200";
                          //   else if (log.progress < 100) bgColor = "bg-yellow-300";
                          //   else bgColor = "bg-lime-600";

                          // } else if (isPast) {
                          //   // ⛔ Past window that is no longer active
                          //   if (!log?.logged) bgColor = "bg-red-600";
                          //   else if (log.progress < 100) bgColor = "bg-yellow-300";
                          //   else bgColor = "bg-lime-600";
                          // }
                          
                          // if (isPast) {
                          //   if (!log?.logged) bgColor = "bg-red-600";
                          //   else if (log.progress < 100) bgColor = "bg-yellow-300";
                          //   else bgColor = "bg-lime-600";
                          // // } else if (isToday) {
                          // } else if (isActivePeriod) {
                          //   if (!log?.logged) bgColor = "bg-orange-200";
                          //   else if (log.progress < 100) bgColor = "bg-yellow-300";
                          //   else bgColor = "bg-lime-600";
                          // } 

                          return (
                            <div
                              key={index}
                              // ref={isToday ? todayLogRef : null} // ✅ attach only to today // 30 Dec 2025 - commented out
                              ref={isActivePeriod ? todayLogRef : null} // 30 Dec 2025 - changed to isActivePeriod
                              className={`w-20 min-w-[5rem] h-20 flex flex-col justify-center items-center ${
                                isFuture || bgColor === "bg-yellow-300" || bgColor === "bg-orange-200" || bgColor === "bg-gray-100"
                                  ? "text-black"
                                  : "text-white"
                              } rounded text-[10px] ${isFuture ? "bg-gray-200 hover:bg-gray-300" : ""} ${
                                bgColor === "bg-red-600" ? "bg-red-600 hover:bg-red-700" :
                                bgColor === "bg-yellow-300" ? "bg-yellow-300 hover:bg-yellow-400" :
                                bgColor === "bg-lime-600" ? "bg-lime-600 hover:bg-lime-700" :
                                bgColor === "bg-orange-200" ? "bg-orange-200 hover:bg-orange-300" :
                                "bg-gray-100 hover:bg-gray-200"
                              }
                               ${isActivePeriod ? "border-black border-2 shadow-black shadow-lg" : ""}`
                               // ${isToday ? "border-black border-2 shadow-black shadow-lg" : ""}
                              
                            
                            }

                              // className={`w-20 min-w-[5rem] h-20 hover:bg-orange-300 flex flex-col justify-center items-center ${
                              //   isFuture || bgColor === "bg-yellow-300" || bgColor === "bg-orange-200" || bgColor === "bg-gray-100"
                              //     ? "text-black"
                              //     : "text-white"
                              // } rounded text-[10px] ${isFuture ? "bg-gray-200" : bgColor}`}
                            >
                              {/* 01 Jan 2026 */}
                              {!isFuture && (
                                <>
                                  <p className="font-bold text-sm">{log?.progress ?? 0}%</p>
                                  <p className="text-[9px]">{log?.actualValue ?? 0} {action?.actionUoM || ""}</p>
                                  <p className="text-[8px] mt-1">
                                    
                                    {/* 30 Dec 2025 */}
                                    {action.actionRecurrencePattern === "Daily" && logMoment.format("DD MMM")}

                                    {action.actionRecurrencePattern === "Weekly" &&
                                      `Week of ${logMoment.format("DD MMM")}`}

                                    {action.actionRecurrencePattern === "BiWeekly" &&
                                      `Bi-Week of ${logMoment.format("DD MMM")}`}

                                    {action.actionRecurrencePattern === "Monthly" &&
                                      logMoment.format("MMM YYYY")}

                                    {action.actionRecurrencePattern === "Quarterly" &&
                                      `Q${logMoment.quarter()} ${logMoment.year()}`}

                                    {action.actionRecurrencePattern === "SemiAnnually" &&
                                      `${logMoment.month() < 6 ? "H1" : "H2"} ${logMoment.year()}`}

                                    {action.actionRecurrencePattern === "Annually" &&
                                      logMoment.format("YYYY")}
                                    
                                    {/* {moment(log?.logDate).format("DD MMM")} */}
                                    
                                    </p>
                                    {/* 01 Jan 2026 */}
                                    {isActivePeriod && !isPast && (
                                      <>
                                        {isDaily ? (
                                          <p className="text-[10px] mt-1 font-bold">Today</p>
                                        ) : (
                                          <>
                                          {log?.progress < 100 && (
                                          <p className="text-[9px] mt-1 font-semibold bg-white rounded-full px-1">
                                            Current Period
                                          </p>)}
                                          </>
                                        )}
                                      </>
                                    )}
                                    {/* {isToday && isDaily && ( */}
                                    {/* 30 Dec 2025 */}
                                    {/* {isActivePeriod && isDaily && !isPast && (
                                      <p className="text-[10px] mt-1 font-bold">Today</p>
                                    )} */}
                                  {/* {isToday && <p className="text-[10px] mt-1 font-bold">Today!</p>} */}
                                </>
                              )}
                              
                              {/* 01 Jan 2026 */}
                              {isFuture && (
                                <>
                                  <p className="text-center font-semibold">To be logged</p>

                                  <p className="text-[8px] mt-1">
                                    {action.actionRecurrencePattern === "Daily" && logMoment.format("DD MMM")}

                                    {action.actionRecurrencePattern === "Weekly" &&
                                      `Week of ${logMoment.format("DD MMM")}`}

                                    {action.actionRecurrencePattern === "BiWeekly" &&
                                      `Bi-Week of ${logMoment.format("DD MMM")}`}

                                    {action.actionRecurrencePattern === "Monthly" &&
                                      logMoment.format("MMM YYYY")}

                                    {action.actionRecurrencePattern === "Quarterly" &&
                                      `Q${logMoment.quarter()} ${logMoment.year()}`}

                                    {action.actionRecurrencePattern === "SemiAnnually" &&
                                      `${logMoment.month() < 6 ? "H1" : "H2"} ${logMoment.year()}`}

                                    {action.actionRecurrencePattern === "Annually" &&
                                      logMoment.format("YYYY")}
                                  </p>

                                  {/* 🔓 Future open indicator */}
                                  <p className="text-[8px] mt-1 text-gray-600 bg-orange-100 rounded-full px-1">
                                    Opens{" "}
                                    {action.actionRecurrencePattern === "Daily" && `on ${logMoment.format("DD MMM")}`}

                                    {action.actionRecurrencePattern === "Weekly" &&
                                      `${logMoment.format("DD MMM")}`}

                                    {action.actionRecurrencePattern === "BiWeekly" &&
                                      `${logMoment.format("DD MMM")}`}

                                    {action.actionRecurrencePattern === "Monthly" &&
                                      logMoment.format("DD MMM")}

                                    {action.actionRecurrencePattern === "Quarterly" &&
                                      // `Q${logMoment.quarter()} ${logMoment.year()}`}
                                      logMoment.format("DD MMM")}

                                    {action.actionRecurrencePattern === "SemiAnnually" &&
                                      // `${logMoment.month() < 6 ? "H1" : "H2"} ${logMoment.year()}`}
                                      logMoment.format("DD MMM")}

                                    {action.actionRecurrencePattern === "Annually" &&
                                      logMoment.format("DD MMM")}
                                  </p>
                                </>
                              )}

                            </div>
                          );
                        })}
                      </div>

                      {/* Optional Right Arrow */}
                      <button 
                        onClick={scrollRight}
                        className="absolute right-0 top-1/2 transform -translate-y-1/2 bg-white z-10 p-1 rounded-full shadow"
                      >
                        <ChevronRightIcon className="h-5 w-5 text-gray-600" />
                      </button>
                    </div>
                  </div>
                )}


                {/* New Note & Progress */}
                {action?.userActionProgress < 100 && (
                  
                  <div className="bg-white mt-2 p-2 rounded">

                    {/* Show Progress Update Form */}
                    {(action?.actionRecurrencePattern === "OneTime" || 
                    // (currentLog && currentLog.progress < 100)) // 30 Dec 2025 - commented out
                    (isActivePeriod && currentLog.progress < 100)) // 30 Dec 2025 - switched to isActivePeriod
                    && (

                      <div className="grid grid-cols-2 gap-4">
                        <div>
                          <p className="font-bold text-xs mb-1 flex items-center">
                            {/* <PlusCircleIcon className="h-4 w-4 text-orange-600 mr-1" /> */}
                            <PlusCircleIcon className="m-2 h-5 w-5 text-orange-600" />
                            {/* Add Note */}
                            {/* 27 Sep 2025 */}
                            {action?.actionRecurrencePattern !== "OneTime" ? (
                                <p>
                                  {/* 30 Dec 2025 */}
                                  {action.actionRecurrencePattern === "Daily"
                                  ? "Add today's Recurring Log Progress Update Note"
                                  : "Add current period Progress Update Note"}
                                  {/* Add today's <span className="bg-orange-100 text-orange-800 rounded-full px-2 py-[1px] mx-1">Recurring Log</span> Progress Update Note */}
                                </p>
                              ) : 'Add a Progress Update Note'}

                          </p>
                          <textarea
                            className="w-full rounded text-[10px] border border-gray-300 p-1"
                            value={actionNote}
                            // onChange={onNoteChange}
                            // onChange={(e) => onNoteChange(e, action?._id, logDateKey)} // 28 Sep 2025
                            onChange={(e) => onNoteChange(e, logDateKey)} // ✅ 28 Sep 2025 - final form
                            placeholder="Add your action note..."
                          />
                        </div>
                        <div>
                          <p className="font-bold text-xs mb-1 flex items-center">
                            {/* <ArrowUpCircleIcon className="h-4 w-4 text-orange-600 mr-1" /> */}
                            <ArrowUpCircleIcon className="m-2 h-5 w-5 text-orange-600"/>
                            {/* Update Progress */}
                            {/* 27 Sep 2025 */}
                            {action?.actionRecurrencePattern !== "OneTime" ? (
                                <p>
                                  Update{" "}
                                  {action.actionRecurrencePattern === "Daily"
                                    ? "today’s"
                                    : "current period’s"}{" "}
                                  <span className="bg-orange-100 text-orange-800 rounded-full px-2 py-[1px] mx-1">
                                    Recurring Log
                                  </span>
                                  Progress
                                </p>
                              ) : 'Update Progress'}

                          </p>
                          <div className="flex items-center">
                            <input
                              type="range"
                              min="0"
                              max="100"
                              className="w-full"
                              value={progressValue}
                              // onChange={onProgressChange}
                              // onChange={(e) => onProgressChange(e, action._id, logDateKey)} // 28 Sep 2025
                              onChange={(e) => onProgressChange(e, logDateKey)} // ✅ 28 Sep 2025 final form
                            />
                            <input
                              type="number"
                              className="w-12 text-center text-[10px] border mx-1"
                              value={progressValue}
                              // onChange={onProgressChange}
                              onChange={(e) => onProgressChange(e, logDateKey)} // ✅ 28 Sep 2025 final form
                            />
                            <span className="text-xs">%</span>
                          </div>            
                        </div>
                      </div>
                      
                    )}

                    {/* 27 Sep 2025 - Completed Log Message for Recurring Actions */}
                    {action?.actionRecurrencePattern !== "OneTime" &&
                      // currentLog &&  // 30 Dec 2025 - commented out
                      isActivePeriod && // 30 Dec 2025
                      currentLog.progress === 100 && (
                        <div className="mt-2 p-2 rounded bg-lime-100 border border-lime-300 text-xs text-gray-800">
                          <p className="mb-1">
                            ✅ You have completed <span className='bg-yellow-100 rounded-full px-2 font-bold border'>today's</span> log.
                          </p>
                          {nextLogDate ? (
                              <p>
                                Please revisit this section on <span className="font-semibold">{formatDate(nextLogDate)}</span>.
                              </p>
                            ) : (
                              <p>You are all set with logging progress!</p>
                            )}

                        </div>
                    )}



                    {/* 26 Sep 2025 - Actual Value */}
                    <div className="grid grid-cols-3 gap-4 justify-between items-center mt-2 p-2 border bg-orange-100 rounded">
                      <div className='col-span-1 flex items-center'>
                        <p className="text-[10px] mx-1 px-1">Actual Value (Today) :</p>

                        {action?.actionRecurrencePattern === "OneTime" || 
                        
                        // (currentLog && currentLog.progress < 100)      // 30 Dec 2025 - commented out
                        (isActivePeriod && currentLog.progress < 100)     // 30 Dec 2025
                        
                        ? (
                          <input
                            type="number"
                            className="w-16 text-center text-[10px] border"
                            value={localActualValue}
                            onChange={(e) => {
                              const value = parseFloat(e.target.value);
                              setLocalActualValue(isNaN(value) ? 0 : value);
                            }}
                          />
                        ) : (
                          <p className="text-[10px] font-semibold text-orange-700 px-2">
                            {currentLog?.actualValue ?? 0}
                          </p>
                        )}

                        {/* <input
                          type="number"
                          className="w-16 text-center text-[10px] border"
                          // value={actualValue}
                          // onChange={onActualValueChange}
                          value={localActualValue}
                          onChange={(e) => {
                            const value = parseFloat(e.target.value);
                            setLocalActualValue(isNaN(value) ? 0 : value);
                          }}
                        /> */}
                      </div>
                      
                      <div className='col-span-1 flex items-center'>
                        <p className="text-[10px] mx-1 px-1 font-bold text-orange-800">Achieved Value (Till Now) :</p>
                        <p className="text-[10px] mx-1 px-1 font-bold text-orange-800">{action?.actualValue}</p>
                        {/* <p className="text-[10px] mx-1 px-1">{action?.actionUoM}</p> */}
                      </div>

                      <div className='col-span-1 flex items-center'>
                        <p className="text-[10px] mx-1 px-1">Target Value :</p>
                        <p className="text-[10px] mx-1 px-1">{action?.targetValue}</p>
                        <p className="text-[10px] mx-1 px-1">{action?.actionUoM}</p>
                      </div>

                    </div>

                    {/* Save button only if currentLog exists and is incomplete, or it's OneTime */}
                    {(action?.actionRecurrencePattern === "OneTime" || 
                    
                    // (currentLog && currentLog.progress < 100)) && // 30 Dec 2025 - commented out
                    (currentLog && isActivePeriod && currentLog.progress < 100)) && // 30 Dec 2025
                    
                    (
                      <div className="flex justify-end mt-2">
                        <button
                          className="text-white bg-orange-600 rounded-full px-3 py-[2px] text-[10px]"
                          onClick={() => onSave(localActualValue)}
                        >
                          Save
                        </button>
                      </div>
                    )}

                    
                  </div>
                )}
                </> 
              )}

              {selectedActionProgressFocusTab === "collective" && (
                <div className="bg-white mt-2 p-2 rounded shadow-inner">
                  {action?.assignedUsers?.length > 0 ? (
                    action.assignedUsers.map((assignedUser, index) => {
                      const matchingAction = userAssignedActions?.find(
                        ua => ua.userId?._id === assignedUser.userId
                      );

                      if (!matchingAction) return null;

                      const userInfo = {
                        _id: matchingAction?.userId?._id,
                        username: matchingAction?.userId?.username,
                        name: matchingAction?.userId?.name,
                      };

                      console.log('userInfo inside collective', userInfo)

                      return (
                        <div key={matchingAction?._id + index} className="my-2">
                          <EtUserAssignedActionCard
                            userInfo={userInfo}
                            userAction={matchingAction}
                          />
                        </div>
                      );
                    })
                  ) : (
                    <p className="text-sm text-gray-500 italic">No assigned users.</p>
                  )}
                </div>
              )}

            </>
          )}

          {activeInnerTab === "Action Performance" && (
            <div className="mt-2">
              {/* Sub-tabs for Self / Collective - inside Action Performance */}
              <div className="flex justify-start space-x-4 border-b border-gray-300 py-1 px-2 mb-2">
                {[
                  { key: "self", label: "Self", Icon: UserIcon },
                  { key: "collective", label: "Collective", Icon: UserGroupIcon }
                ].map(({ key, label, Icon }) => (
                  <button
                    key={key}
                    onClick={() => setSelectedActionPerformanceFocusTab(key)}
                    className={`flex items-center space-x-2 px-3 py-1 text-sm font-semibold border-b-2 ${
                      selectedActionPerformanceFocusTab === key
                        ? "border-orange-600 text-orange-600"
                        : "border-transparent text-gray-500"
                    }`}
                  >
                    <div
                      className={`h-7 w-7 flex justify-center items-center rounded-full ${
                        selectedActionPerformanceFocusTab === key
                          ? "bg-gradient-to-r from-orange-600 to-orange-800 shadow-md"
                          : "bg-gray-100 hover:bg-orange-100"
                      }`}
                    >
                      <Icon
                        className={`h-4 w-4 ${
                          selectedActionPerformanceFocusTab === key ? "text-white" : "text-orange-600"
                        }`}
                      />
                    </div>
                    <p className="text-sm font-medium">{label}</p>
                  </button>
                ))}
              </div>

              {/* 30 Sep 2025 - Self Performance Tab details */}
              {selectedActionPerformanceFocusTab === "self" && (
                <div>
                  <EtUserActionPerformanceSelfChart action={action} />
                </div>
              )}


              {/* 05 Jan 2026 - Collective Performance Refinements */}
              {selectedActionPerformanceFocusTab === "collective" && (
                <div>
                  {!performanceSnapshot ? (
                    <p className="text-xs text-gray-500 italic">
                      No collective performance available.
                    </p>
                  ) : (
                    <>
                      {/* 🟠 Collective Performance Header */}
                      <div className="flex items-center gap-2 mb-1">
                        <UserGroupIcon className="h-4 w-4 text-orange-600" />
                        <p className="text-xs font-semibold text-orange-800">
                          Collective Performance (All Contributors)
                        </p>
                      </div>

                      {/* 🟠 Collective Summary */}
                      <div className="bg-orange-50 border border-orange-300 rounded p-2 mb-2">
                        <div className="grid grid-cols-3 gap-4 text-xs">
                          <div>
                            <p className="font-bold">Achieved</p>
                            <p>
                              {performanceSnapshot.achievedValue}{" "}
                              {performanceSnapshot.uom}
                            </p>
                          </div>

                          <div>
                            <p className="font-bold">Target</p>
                            <p>
                              {performanceSnapshot.targetValue}{" "}
                              {performanceSnapshot.uom}
                            </p>
                          </div>

                          <div>
                            <p className="font-bold">Target Performance</p>
                            <p>{performanceSnapshot.progressPercent}%</p>
                          </div>
                        </div>
                      </div>

                      {/* 🆕 Collective Performance Sub-Tabs */}
                      <div className="flex space-x-4 border-b border-gray-300 mb-3">
                        {[
                          { key: "chart", label: "Performance Chart" },
                          { key: "contributions", label: "Performance Contributions" },
                        ].map(tab => (
                          <button
                            key={tab.key}
                            onClick={() => setActiveCollectivePerformanceTab(tab.key)}
                            className={`px-3 py-1 text-sm font-semibold border-b-2 ${
                              activeCollectivePerformanceTab === tab.key
                                ? "border-orange-600 text-orange-600"
                                : "border-transparent text-gray-500"
                            }`}
                          >
                            {tab.label}
                          </button>
                        ))}
                      </div>

                    
                      {/* 📊 Collective Contributor Performance Cards */}
                      {activeCollectivePerformanceTab === "contributions" && (
                        <>
                          <p className='text-lg font-bold m-1 p-1'>Performance Contributions</p>
                          {performanceSnapshot?.contributors?.length > 0 && (
                            <div className="grid grid-cols-2 md:grid-cols-3 gap-3 mt-4">
                            
                              {performanceSnapshot.contributors.map((c, idx) => {
                                const isMe = c.userId === action?.userId?._id;

                                return (
                                  <div
                                    key={`${c.userId}-${idx}`}
                                    className="bg-white rounded-lg p-3 shadow-sm border text-center"
                                  >
                                    <CircularProgressbarWithChildren
                                      value={c.percentOfTarget}
                                      circleRatio={0.75}
                                      styles={{
                                        path: {
                                          stroke: "#f97316",
                                          transform: "rotate(-135deg)",
                                          transformOrigin: "center center",
                                        },
                                        trail: {
                                          stroke: "#e5e7eb",
                                          transform: "rotate(-135deg)",
                                          transformOrigin: "center center",
                                        },
                                      }}
                                    >
                                      {/* Avatar */}
                                      {/* 07 Jan 2026 */}
                                      <div className="flex justify-center">
                                        <User
                                          username={c.username}
                                          defaultUserPic={userProfileIcon2}
                                        />
                                      </div>
                                      {/* <div className="flex justify-center">
                                        <div className="h-7 w-7 rounded-full bg-orange-100 flex items-center justify-center text-xs font-bold text-orange-700">
                                          {getFirstName(c.userName)?.[0]}
                                        </div>
                                      </div> */}

                                      {/* Name */}
                                      <p className="text-[10px] font-semibold mt-1">
                                        {getFirstName(c.userName)}
                                        {isMe && (
                                          <span className="ml-1 text-[9px] text-orange-600 font-bold">
                                            (Me)
                                          </span>
                                        )}
                                      </p>

                                      {/* Progress */}
                                      <p className="text-xs font-bold text-gray-700">
                                        {c.percentOfTarget}%
                                      </p>

                                      {/* Actual contribution */}
                                    <p className="text-[10px] text-gray-500">
                                      {c.actualValue} {performanceSnapshot.uom}
                                    </p>
                                    </CircularProgressbarWithChildren>   
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </>
                      )}

                      {/* {activeCollectivePerformanceTab === "chart" && (
                        <EtUserActionPerformanceCollectiveChart
                          performanceSnapshot={performanceSnapshot}
                          action={action}
                          loggedInUserId={action?.userId?._id}
                        />
                      )} */}
                      {activeCollectivePerformanceTab === "chart" && (
                        <EtUserActionPerformanceCollectiveTimeSeriesChart
                        rootAction={action}
                        collectiveActions={collectiveActions}
                        loggedInUserId={action?.userId?._id}
                      />
                      )}
        
                    </>
                  )}
                </div>
              )}
              
            </div>
          )}

        </div>
      )}
    </div>
  )
}

export default EtUserSessionActionCard